(function ($) {
  (function () {
    jQuery(document).ready(function () {
      intTab();
    });
  })();

  function intTab() {
    // const tabContainerCls = 'tab-container';
    // const $tabContainer = document.querySelector('.'+tabContainerCls);
    // const tabsetLink = $tabContainer.querySelectorAll('.tabset__item-link');
    // const tabItem = $tabContainer.querySelectorAll('.tab-content__item');
    // const hideCls = 'hidden';
    // const activeCls = 'active';
    var $tabContainer = jQuery('.tab-container');
    var tabsetLink = jQuery('.tabset__item-link');
    var tabItem = jQuery('.tab-content__item');
    var hideCls = 'hidden';
    var activeCls = 'active'; // tabsetLink.forEach(function(link) {
    //     link.addEventListener('click', changeTab);
    // });

    jQuery(tabsetLink).each(function (index, link) {
      jQuery(link).click(function (e) {
        e.preventDefault();
        changeTab(this);
      });
    });

    function changeTab(targetTab) {
      dynamycToggleClass(tabsetLink, 'removeClass', activeCls);
      dynamycToggleClass(targetTab, 'addClass', activeCls);
      var targetId = jQuery(targetTab).attr('href');
      var finedElemById = $tabContainer.find(targetId);
      dynamycToggleClass(tabItem, 'addClass', hideCls);
      jQuery(finedElemById).hasClass(hideCls) ? jQuery(finedElemById).removeClass(hideCls) : null;
    }

    function defineActive() {
      jQuery(tabsetLink).each(function (index, link) {
        if (jQuery(link).hasClass(activeCls)) {
          var targetId = jQuery(link).attr('href');
          var finedElemById = jQuery($tabContainer).find(targetId);
          finedElemById.removeClass(hideCls);
        }
      });
    }

    function dynamycToggleClass(array, method, cls) {
      jQuery(array).each(function (index, tabItem) {
        jQuery(tabItem)[method](cls);
      });
    }

    var tabsetItemCount = 0;
    $('.tabset__item').each(function (i, e) {
      if (i > 0) {
        tabsetItemCount++;
      }
    });

    if (tabsetItemCount > 0) {
      jQuery('.tab-content__item').each(function (i, item) {
        jQuery(item).addClass('hidden');
      });
    }

    dynamycToggleClass(tabsetLink, 'removeClass', activeCls);
    dynamycToggleClass(tabsetLink[0], 'addClass', activeCls);

    if (tabsetItemCount > 0) {
      dynamycToggleClass(tabItem, 'addClass', hideCls);
    }

    defineActive();
  }
})(jQuery);